import axios from "axios";
import { employee, proxy } from "@/urls";

const defaultRequest = {
  tipo: null,
  testo: null,
};

export default {
  namespaced: true,
  state: {
    notices: [],
    requests: [],
    currentRequest: {},
    yearData: {},
    profile: {},
    avvisiNonLetti: null,
  },
  getters: {
    notices: (state) => state.notices,
    requests: (state) => state.requests,
    currentRequest: (state) => state.currentRequest,
    yearData: (state) => state.yearData,
    profile: (state) => state.profile,
    avvisiNonLetti: (state) => state.avvisiNonLetti,
  },
  mutations: {
    SET_NOTICES(state, data) {
      state.notices = data;
    },
    SET_REQUESTS(state, data) {
      state.requests = data;
    },
    SET_CURRENT_REQUEST(state, data) {
      state.currentRequest = data;
    },
    SET_YEARDATA(state, data) {
      state.yearData = data;
    },
    SET_PROFILE(state, data) {
      state.profile = data;
    },
    SET_AVVISINONLETTI(state, data) {
      state.avvisiNonLetti = data;
    },
    DECREASE_AVVISINONLETTI(state) {
      state.avvisiNonLetti--;
    },
    UNMARK_AVVISO(state, id) {
      const i = state.notices.findIndex((item) => item.id === id);
      state.notices[i].letto = true;
    },
  },
  actions: {
    resetNotices({ commit }) {
      commit("SET_NOTICES", []);
    },
    resetRequests({ commit }) {
      commit("SET_REQUESTS", []);
    },
    resetCurrentRequest({ commit }) {
      commit("SET_CURRENT_REQUEST", { ...defaultRequest });
    },
    resetYearData({ commit }) {
      commit("SET_YEARDATA", {});
    },
    resetProfile({ commit }) {
      commit("SET_PROFILE", {});
    },
    async fetchAvvisiNonLetti({ dispatch, commit }) {
      commit("SET_AVVISINONLETTI", null);
      try {
        const { data } = await axios.get(employee.NUM_AVVISI_NUOVI_URL);
        commit("SET_AVVISINONLETTI", data);
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    async markRead({ dispatch, commit }, id) {
      try {
        await axios.put(`${employee.FETCH_NOTICES_URL}/${id}`);
        commit("DECREASE_AVVISINONLETTI");
        commit("UNMARK_AVVISO", id);
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    async fetchMyNotices({ dispatch, commit }, payload = { da: null, a: null }) {
      commit("SET_NOTICES", []);
      try {
        const { data } = await axios.get(
          employee.FETCH_NOTICES_URL,
          { params: { dataDa: payload.da, dataA: payload.a } }
        );
        commit("SET_NOTICES", data);
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    /*** REQUESTS ***/
    async fetchRequests({ dispatch, commit }, payload = { da: null, a: null }) {
      commit("SET_REQUESTS", []);
      try {
        const { data } = await axios.get(
          employee.FETCH_REQUESTS_URL,
          { params: { dataDa: payload.da, dataA: payload.a } }
        );
        commit("SET_REQUESTS", data);
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    async createRequest({ dispatch }, payload) {
      try {
        let formData = new FormData();
        if (payload.file) {
          formData.append("file", payload.file, payload.file.name);
          payload.request.nomeDoc = payload.file.name;
        }
        formData.append(
          "jsonRichiesteDTO",
          JSON.stringify(payload.request)
        );
        await axios.post(employee.CREATE_REQUESTS_URL, formData);
        dispatch("snackbar/openSnackbar", "Richiesta inviata con successo", {
          root: true,
        });
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    downloadRequest({ dispatch }, payload) {
      axios({
        url: `${employee.DOWNLOAD_REQUEST_URL}/${payload.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          var extension = payload.nomeDoc.split(".").pop();
          if (extension !== "pdf") {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", payload.nomeDoc);
            document.body.appendChild(fileLink);

            fileLink.click();
          } else {
            var file = new Blob([response.data], { type: "application/pdf" });
            var url = URL.createObjectURL(file);
            window.open(url);
          }
        })
        .catch((err) =>
          dispatch("snackbar/openErrorSnackbar", err, { root: true })
        );
    },
    /*** REQUESTS ***/
    async fetchYearData({ dispatch, commit, rootGetters }, anno) {
      commit("SET_YEARDATA", {});
      try {
        const account = rootGetters["account/account"];
        const { data } = await axios.get(
          `${employee.FETCH_YEARDATA_URL}/${account.codFiscale}`,
          { params: { anno } }
        );
        commit("SET_YEARDATA", data);
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
    async fetchProfile({ dispatch, commit, rootGetters }) {
      commit("SET_PROFILE", {});
      try {
        const account = rootGetters["account/account"];
        const { data } = await axios.get(
          `${employee.FETCH_PROFILE_URL}/${account.codFiscale}`
        );
        commit("SET_PROFILE", data);
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },

    async fetchNonLetti({ dispatch, rootGetters }) {
      try {
        const account = rootGetters["account/account"];
        const { data } = await axios.get(
          `${proxy.NUM_DOC_NUOVI_URL}/${account.codFiscale}`
        );
        dispatch("payroll/setBpnonletti", data.nuoviCedolini, { root: true });
        dispatch("cud/setCudnonletti", data.nuoviCud, { root: true });
        dispatch("document/setDocsnonletti", data.nuoviDocumentiDip, {
          root: true,
        });
      } catch (err) {
        dispatch("snackbar/openErrorSnackbar", err, { root: true });
      }
    },
  },
};
